import { render, staticRenderFns } from "./eskiin-policy.vue?vue&type=template&id=370be829&scoped=true&"
import script from "./eskiin-policy.vue?vue&type=script&lang=js&"
export * from "./eskiin-policy.vue?vue&type=script&lang=js&"
import style0 from "./eskiin-policy.vue?vue&type=style&index=0&id=370be829&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370be829",
  null
  
)

export default component.exports